module.exports = __webpack_public_path__ + "img/Alan-Fernandes-Design.bbe1121e.webp";